import { HStack, Stat, Badge } from '@chakra-ui/react';
import React from 'react';

interface StatWithChangeProps {
  label: string;
  value: string | number;
  percentChange?: number;
  unit?: string;
}

const StatWithChange: React.FC<StatWithChangeProps> = ({
  label,
  value,
  percentChange,
  unit,
}) => {
  const trendPercentage = percentChange ?? 0;
  const showChange = trendPercentage !== 0;
  const isPositiveChange = trendPercentage > 0;
  const colorScheme = isPositiveChange ? 'red' : 'green';

  return (
    <Stat.Root>
      <Stat.Label>{label}</Stat.Label>
      <HStack>
        <Stat.ValueText>
          {value}
          {unit && (
          <Stat.ValueUnit>
            {' '}
            {unit}
          </Stat.ValueUnit>
          )}
        </Stat.ValueText>
        {showChange && (
          <Badge
            colorScheme={colorScheme}
            data-testid="trend-badge"
            data-type={isPositiveChange ? 'up' : 'down'}
          >
            {isPositiveChange ? (
              <Stat.UpIndicator data-testid="trend-up-icon" />
            ) : (
              <Stat.DownIndicator data-testid="trend-down-icon" />
            )}
            {Math.abs(trendPercentage)}
            %
          </Badge>
        )}
      </HStack>
    </Stat.Root>
  );
};

export default StatWithChange;
